export default "__VITE_ASSET__DzM6iE5C__"